export enum PersonGenders {
    Not_Specified = "N",
    Male = "M",
    Female = "F",
    Non_Binary = "NB",
}